(function () {
    'use strict';
    var controllerId = 'docenteMateriaAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', docenteMateriaAddFn]);

    function docenteMateriaAddFn($scope, $uibModalInstance, datacontext) {
        $scope.materie = getMaterie();

        $scope.ok = function () {
            $scope.filterMateria = '';
            var materieList = [];
            $("input:checkbox[name=materiaId]:checked").each(function () {
                materieList.push($(this).val());
            });
            var result = addItems(materieList);
            $uibModalInstance.close(result);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItems(materieList) {
            return datacontext.materia_docenteImportList(materieList).then(function (data) {
                if (!data || data.Id == null || data.Id == 0) return null;

                return data;
            });
        }

        function getMaterie() {
            return datacontext.materia_getAllListComplete().then(function (data) {
                $scope.materie = data;
            });
        }
    }
})();
